import React, {useRef, useState} from 'react';
import { Form, Label, Input, FormGroup, FormFeedback } from 'reactstrap';
import Buttons from '../Buttons';
import AgentSelect from '../AgentSelect';
import { emailIsValid } from "../../../../../helpers";

const AgentFound = ({agent, handleForm, onClose, backToFind}) => {
  const [emailValid, setEmailValid] = useState("")
  const [nameValid, setNameValid] = useState("")
  const [count, setCount] = useState(0);

  const firstNameRef = useRef()
  const lastNameRef = useRef()
  const emailRegisterRef = useRef()
  const registerCellphoneRef = useRef()
  const registerMessageRef = useRef()

  const handleSubmit = () => {
    const firstName = firstNameRef.current.value
    const lastName = lastNameRef.current.value
    const email = emailRegisterRef.current.value;

    if( !firstName || !lastName) {
      return setNameValid("error")
    }

    if(!emailIsValid(email)) {
      return setEmailValid("error")
    }

    handleForm({
      firstName,
      lastName,
      emailAddr: email,
      mobilephone: registerCellphoneRef.current.value,
      notes: registerMessageRef.current.value,
      agentId: agent.Id,
    },
    "createLead")
  }

  return (
    <>
      <AgentSelect details={true} data={agent}/>
      <Form className="dyna-form login-form">
        <Label for="firstName" className="login-form-label required">Full Name:</Label>
        <FormGroup className="inline-form">
          <Input invalid={nameValid === "error"} innerRef={firstNameRef} className="mg-btm-10" type="name" name="firstName" id="firstName" placeholder="Enter First Name" />
          <Input invalid={nameValid === "error"} innerRef={lastNameRef} className="mg-btm-10" type="name" name="lastName" id="lastName" placeholder="Enter Last Name" />
        </FormGroup>
        <FormFeedback>
          Please enter a valid name.
        </FormFeedback>
        <Label for="emailRegister" className="login-form-label required">Email:</Label>
        <Input
          innerRef={emailRegisterRef}
          className="mg-btm-10"
          type="email"
          name="emailRegister"
          id="emailRegister"
          placeholder="Enter your email"
          invalid={emailValid === "error"}
        />
        <FormFeedback>
          Please input a correct email.
        </FormFeedback>
        <Label for="registerCellphone" className="login-form-label">Phone:</Label>
        <Input innerRef={registerCellphoneRef} className="mg-btm-10" type="tel" pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}" name="registerCellphone" id="registerCellphone" placeholder="Enter your phone" />
        <Label for="registerMessage" className="login-form-label">Message:</Label>
        <Input
          innerRef={registerMessageRef}
          className="mg-btm-10 register-message"
          name="registerMessage"
          id="registerMessage"
          type="textarea"
          maxLength="300"
          onChange={e => setCount(e.target.value.length)}
        />
        <p className="char-count">{300 - count} characters left</p>
        <p className="agreement">By choosing to create an account with this Listing Agent your account will be linked to this Agent and until he/she creates your account, you will not be able to contact another Listing Agent. From this moment forward all interactions will be made with this Agent.</p>
      </Form>
      <Buttons
        type={"AgentFound"}
        onSubmit={handleSubmit}
        onClose={onClose}
        backToFind={backToFind}
      />
    </>
  )
}

export default AgentFound